<template>
  <div>
    <div class="banner">
      <div class="headerReplacementBasicInfo"></div>
      <div class="banner-text">
        <b>การประชุมผู้ถือหุ้น</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
          <span class="separator"></span>
          <span>ข้อมูลผู้ถือหุ้น</span>
          <span class="separator"></span>
          <span><b>การประชุมผู้ถือหุ้น</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <BasicInfoTabMenu />
      </div>

      <!-- Year Select Dropdown -->
      <div class="row g-3 row justify-content-end mb-3">
        <div class="col-auto">
          <label class="col-form-label">เลือกปี</label>
        </div>
        <div class="col-auto">
          <select id="yearSelect" v-model="selectedYear" class="form-select" aria-label="Year selection">
            <option value="2025">2025</option>
            <option value="2024">2024</option>
            <option value="2023">2023</option>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
            <option value="2020">2020</option>
            <!-- <option value="2019">2019</option>
            <option value="2018">2018</option>
            <option value="2017">2017</option>
            <option value="2016">2016</option> -->
          </select>
        </div>
      </div>

      <!-- Tabs for Meeting Types -->
      <div class="row mb-3">
        <div class="col">
          <ul class="nav nav-tabs nav-justified" id="meetingTabs" role="tablist">
            <li class="nav-item" v-for="(type, index) in sortedMeetingTypes" :key="index">
              <a class="nav-link" :class="{ active: selectedMeetingType === type }" @click="selectMeetingType(type)"
                href="javascript:void(0)">
                การประชุมสามัญผู้ถือหุ้น
                <span v-if="type === '0'">{{ selectedYear }}</span>
                <span v-else>ครั้งที่ {{ type }}/{{ selectedYear }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Table of Meetings -->
      <table class="table mb-5">
        <thead>
          <tr class="table-secondary">
            <th scope="col"><b> การประชุมสามัญผู้ถือหุ้น ประจำปี {{ selectedYear }}</b></th>
            <th scope="col" class="text-end"><b>เอกสาร</b></th>
          </tr>
        </thead>
        <tbody>
          <!-- Show the meeting rows if there are filtered data -->
          <tr v-for="(item, index) in filteredListByType" :key="index">
            <td style="width: 90%;"> {{ item.meeting_name }}</td>
            <td class="text-end">
              <a :href="item.meeting_url" target="_blank" class="text-decoration-none">
                <p class="card-text text-secondary">
                  <small class="text-muted">
                    <i class="fa-solid fa-download"></i> ดาวน์โหลด
                  </small>
                </p>
              </a>
            </td>
          </tr>

          <!-- Show a message if there are no filtered data -->
          <tr v-if="filteredListByType.length <= 0">
            <td colspan="2" class="text-center text-muted">
              <p class="mt-3">ไม่มีข้อมูลการประชุมสำหรับปีนี้</p> 
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import store from "@/store";
import { GET_MEETINGS_DATA } from "../../store/actions.type";

export default {
  name: 'MajorShareholders',
  components: {
    BasicInfoTabMenu,
  },
  data() {
    return {
      selectedYear: '2025',
      selectedMeetingType: '0',
      list: [],
      meetingTypes: [],
      isLoading: false,

    };
  },
  async created() {
    this.isLoading = true;
    await this.init();
    this.isLoading = false;
    this.meetingTypes = [...new Set(this.list.map(item => item.meeting_type))];
  },
  computed: {
    sortedMeetingTypes() {
      return this.meetingTypes.sort((a, b) => b - a);
    },
    filteredList() {
      return this.list.filter(item => item.meeting_year.toString() === this.selectedYear);
    },
    filteredListByType() {
      return this.filteredList
        .filter(item => {
          if (this.selectedMeetingType === '') {
            return true;
          }
          return item.meeting_type === this.selectedMeetingType;
        })
        .sort((a, b) => a.meeting_year - b.meeting_year);
    }
  },
  methods: {
    async init() {
      this.list = await store.dispatch(GET_MEETINGS_DATA);
    },
    selectMeetingType(type) {
      this.selectedMeetingType = type;
    }
  },
}
</script>

<style scoped>
.nav-link {
  color: #000000;
}

.nav-link:hover {
  color: #000000;
}

.nav-link.active {
  color: #E87D2E;
  font-weight: bold;
}
</style>
